import { useSelector } from 'react-redux';

import Modal from 'app/components/Modal';

import {
  selectViewportMobile
} from 'app/reducers/viewportReducer';

const ResourceModal = props => {
  const {
    isOpen,
    onClose,
    title,
    subTitle,
    message,
    center,
    unmountOnClose,
    children,
    width
  } = props;

  const isMobile = useSelector(state => state.portalReducer.isMobile);

  // align form modal to right of screen on desktop
  const modalStyle = {};
  if (!isMobile && !center) {
    modalStyle.justifyContent = 'end';
    modalStyle.marginRight = '1.5rem';
  }

  const paperStyle = {
    top: '2rem'
  }

  if (width) {
    paperStyle.maxWidth = width;
  }

  let msg = null;
  if (message) {
    msg = <p>{message}</p>;
  }

  // keepMounted was introduced here to help with performance,
  // but it doesn't appear to help at all and is causing issues.
  // the performance issues in the job modal were otherwise addressed.
  // keeping this here in case we change our mind but disabling for now
  //let keepMounted = !unmountOnClose;
  let keepMounted = false;

  return (
    <Modal {...{
      open: isOpen,
      onClose,
      title,
      subTitle,
      modalStyle,
      paperStyle,
      keepMounted
    }}>
      {msg}
      {children}
    </Modal>
  );
}

export default ResourceModal;
